import Cookies from 'js-cookie';

const app = {
  namespaced: true,
  state: {
    language: Cookies.get('language') || 'zh',
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
      Cookies.set('language', language);
    },
  },
};

export default app;
